import React, { useState } from 'react';
import api from '../../../config/api-config';
import { useAuth } from '../../../context/AuthContext';
import LogoutButton from '../Misc/LogoutButton';
import './Sidebar.css';

const Sidebar = ({ isOpen, onClose, onAddComponent, onOpenSettings, onOpenShare }) => {
  const [generatedString, setGeneratedString] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const { user } = useAuth();
  
  const handleGenerate = async () => {
    try {
      setIsLoading(true);
      
      // Extract boardId from URL path
      const pathParts = window.location.pathname.split('/');
      let boardId = null;
      
      // Find the board ID in the URL
      for (let i = 0; i < pathParts.length; i++) {
        if (pathParts[i] === 'board' && i + 1 < pathParts.length) {
          boardId = pathParts[i + 1];
          break;
        }
      }
      
      console.log('Extracted boardId from URL:', boardId);
      
      if (!boardId) {
        console.error('Could not determine current board ID from URL');
        setGeneratedString('Error: Could not determine current board. Please make sure you are viewing a board.');
        return;
      }
      
      // Get auth token
      const token = await user.getIdToken();
      
      console.log('Making API request to /api/generate with boardId:', boardId);
      
      const response = await api.get('/api/generate', {
        headers: {
          'Authorization': `Bearer ${token}`,
        },
        params: {
          boardId: boardId
        }
      });
      
      console.log('API response received:', response.status);
      setGeneratedString(response.data.generatedString);
    } catch (error) {
      console.error('Error generating suggestion:', error);
      
      // Provide more detailed error message
      let errorMessage = 'Error generating suggestion. ';
      
      if (error.response) {
        // The request was made and the server responded with a status code
        // that falls out of the range of 2xx
        console.error('Error response data:', error.response.data);
        console.error('Error response status:', error.response.status);
        
        errorMessage += error.response.data.message || 
                       `Server returned status ${error.response.status}`;
      } else if (error.request) {
        // The request was made but no response was received
        errorMessage += 'No response received from server. Please check your connection.';
      } else {
        // Something happened in setting up the request that triggered an Error
        errorMessage += error.message || 'Unknown error occurred';
      }
      
      setGeneratedString(errorMessage);
    } finally {
      setIsLoading(false);
    }
  };
  
  return (
    <div className={`sidebar ${isOpen ? 'open' : ''}`}>
      <div className="sidebar-header">
        <h3>Board Tools</h3>
        <button className="close-sidebar-button" onClick={onClose}>×</button>
      </div>
      <div className="sidebar-content">
        <div className="sidebar-section">
          <h4>Board Settings</h4>
          <ul className="sidebar-menu">
            <li>
              <button 
                className="sidebar-button"
                onClick={() => {
                  onOpenSettings && onOpenSettings();
                  onClose();
                }}
              >
                <span className="sidebar-icon">⚙️</span>
                <span>Settings</span>
              </button>
            </li>
            <li>
              <button 
                className="sidebar-button"
                onClick={() => {
                  onOpenShare && onOpenShare();
                  onClose();
                }}
              >
                <span className="sidebar-icon">👥</span>
                <span>Share</span>
              </button>
            </li>
            <li>
              <button 
                className="sidebar-button"
                onClick={handleGenerate}
                disabled={isLoading}
              >
                <span className="sidebar-icon">🔄</span>
                <span>{isLoading ? 'Generating...' : 'Generate Suggestion'}</span>
              </button>
            </li>
          </ul>
        </div>
        
        {generatedString && (
          <div className="sidebar-section">
            <h4>AI Suggestion</h4>
            <div className="generated-string">
              {generatedString}
            </div>
          </div>
        )}
      </div>
      <div className="sidebar-footer">
        <LogoutButton />
      </div>
    </div>
  );
};

export default Sidebar;
